var exports = {
  "o": "CommitSelectorWrapper__8GXbxT",
  "m": "CommitSelectorContainer__OW_6WL",
};

module.exports = exports;
